import React from 'react';
import './FullScreenLoader.css'; 

const FullScreenLoader = () => {
    return (
        <div className="fullscreen-loader">
            <div className="spinner"></div>
            <p>Loading...</p>
        </div>
    );
};

export default FullScreenLoader;
